import React from 'react'

const WhyChoose = () => {
    return (
        <>
            <section className="about_us_2 pt_120 xs_pt_100 pb_120 xs_pb_100">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-9 wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                            <div className="about_us_2_img">
                                <img src="assets/images/about_us_2_img.png" alt="about" className="img-fluid w-100" />
                                <div className="text">
                                    <h5>5+</h5>
                                    <p>Years Experience</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 wow fadeInRight" style={{ visibility: 'visible', animationName: 'fadeInRight' }}>
                            <div className="about_us_2_contant">
                                <div className="section_heading_2">
                                    <h6>Why Choose us</h6>
                                    <h2>Why Choose Sewax Services Private Limited?</h2>
                                </div>
                                <p style={{textAlign:"justify"}}>At Sewax Services Private Limited, we are committed to delivering professional, reliable, and result-driven solutions under one roof. With expertise across multiple industries, we help individuals, businesses, and organizations achieve their goals through quality services, transparent processes, and exceptional customer support. Our customer-first approach, experienced professionals, and dedication to excellence make us a trusted partner for all your personal and business needs.</p>
                                <ul>
                                    <li style={{width:"100%"}}>
                                        <h6>Our Mission</h6>
                                        <span style={{textAlign:"justify"}}>Our mission is to provide reliable, affordable, and high-quality services that simplify business operations and improve people's lives. We strive to become a one-stop destination where customers receive professional solutions with complete transparency, efficiency, and customer satisfaction.</span>
                                    </li>
                                    
                                    <li style={{width:"100%"}}>
                                        <h6>Our Vision</h6>
                                        <span style={{textAlign:"justify"}}>Our vision is to become India's most trusted multi-service company by continuously expanding our expertise, embracing innovation, and delivering excellence in every service we offer. We aim to empower businesses and individuals with dependable solutions that create lasting value.</span>
                                    </li>
                                </ul>
                                {/* <div className="about_us_2_contant_bottom">
                                    <div className="about_us_2_contant_contact">
                                        <div className="img">
                                            <img src="assets/images/call_blue_bg.png" alt="icon" className="img-fluid w-100" />
                                        </div>
                                        <div className="text">
                                            <span>Any time Call Us</span>
                                            <a href="callto:+22256456825">+222 (564) 568 25</a>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section className="why_choose_us pt_110 xs_pt_90 pb_120 xs_pb_100" style={{marginTop:"-90px"}}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="section_heading mb_45">
                                <h5>Why we choose us </h5>
                                <h2>Reasons to Choose Us</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-xl-4 wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                            <div className="why_choose_text">
                                <ul>
                                    <li>
                                        <div className="icon">
                                            <img src="assets/images/why_choose_icon_1.svg" alt="Why Choose" className="img-fluid" />
                                        </div>
                                        <div className="text">
                                            <h3>One-Stop Business & Facility Solutions</h3>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <img src="assets/images/why_choose_icon_2.svg" alt="Why Choose" className="img-fluid" />
                                        </div>
                                        <div className="text">
                                            <h3>Experienced & Certified Professionals</h3>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <img src="assets/images/why_choose_icon_3.svg" alt="Why Choose" className="img-fluid" />
                                        </div>
                                        <div className="text">
                                            <h3>Quality-Driven Service Delivery</h3>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="why_choose_img">
                                <img src="assets/img/why_choose_2.webp" alt="Why Choose Us" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-xl-4 wow fadeInRight" style={{ visibility: 'visible', animationName: 'fadeInRight' }}>
                            <div className="why_choose_text">
                                <ul>
                                    <li>
                                        <div className="icon">
                                            <img src="assets/images/why_choose_icon_4.svg" alt="Why Choose" className="img-fluid" />
                                        </div>
                                        <div className="text">
                                            <h3>24/7 Online Support</h3>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <img src="assets/images/why_choose_icon_5.svg" alt="Why Choose" className="img-fluid" />
                                        </div>
                                        <div className="text">
                                            <h3>Transparent Pricing & Honest Communication</h3>
                                           
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <img src="assets/images/why_choose_icon_6.svg" alt="Why Choose" className="img-fluid" />
                                        </div>
                                        <div className="text">
                                            <h3>Long-Term Partnership & Dedicated Support</h3>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WhyChoose